import React from 'react';
import "../Figure.css"


function Figure5() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Cd concentration after incubation (30min)</th>
              <th> Cd uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 0.305 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20 </th>
              <td> 0.138 mg/L </td>
              <td> 0.167 mg/L </td>
            </tr> 
            <tr>
              <th> SpaC </th>
              <td> 0.167 mg/L </td>
              <td> 0.138 mg/L </td>
            </tr> 
            <tr>
              <th className="colored-cell"colSpan="2"> Uptake difference </th>
              <th className="colored-cell"> 0.029 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure5;